// extracted by mini-css-extract-plugin
export var actionText = "_m3-4";
export var container = "_m3-0";
export var leftSection = "_m3-1";
export var rightSection = "_m3-2";
export var settingsButton = "_m3-6";
export var settingsIcon = "_m3-7";
export var shortcut = "_m3-5";
export var shortcutGroup = "_m3-3";